// extracted by mini-css-extract-plugin
module.exports = {"vehicleInfoContainer":"vehicle-info_vehicleInfoContainer__zqcDo","row":"vehicle-info_row__2fAcF","bold":"vehicle-info_bold__jwK5z","img":"vehicle-info_img__2s-T4"};